import ProjectCard from "./Components/ProjectCard";
import GitRepoCard from "./Components/GitRepoCard";
import Websites from "../Data/Websites.json";
import GitRepo from "../Model/GitRepo";

function Work({inRepos}: {inRepos: GitRepo[]}) {

    function getGitRepos() {
        if (inRepos.length === 0) {
            return (
                <div>
                    No Github repository found. Come back again later!
                </div>
            );
        }

        return (
            <div>
                {
                    inRepos.slice(0, 5).map(repo => (
                        <GitRepoCard
                            key={repo.name}
                            inRepo={repo} />
                    ))
                }
                <p>And many more...</p>
            </div>
        )
    }

    return (
        <div className="page_content">

            {/* Agape Software */}
            <h1 className="centered_headers">
                AGAPE SOFTWARE, LLC
            </h1>

            <div className="projects_PI">
                <img src="/images/website/agapesoftwareLogo.png" alt="logo" className="projects_PIicons" />
            </div>
            <p>
                Agape Software, LLC is a software company that specializes in creating custom, high performance software for every platform.
            </p>
            <p>
                We update and maintain the release of our own software products like the <a href="https://github.com/Agape-Software-LLC/MarkTwo" target="_blank">MarkTwo game engine.</a>
            </p>
            <p>
                If you are interested in getting in contact, click the link to <a href="mailto:contact@agape-software.com"> email us.</a>
            </p>

            {/* Web */}
            <h1 className="centered_headers">
                WEBSITES
            </h1>
            <div>
                {/* lukaspowers.com website */}
                <p>I made the website you're currently on. <a href="https://lukaspowers.substack.com/p/a-video-game-developer-makes-a-website" target="_blank">Here</a> is the link to an article where I talk about the development process.</p>
                {
                    Websites && Websites.map(website => (
                        <ProjectCard
                            key={website.title}
                            title={website.title}
                            description={website.description}
                            url={website.url}
                        />
                    ))
                }

            </div>

            {/* Github */}
            <h1 className="centered_headers">
                LATEST FROM GITHUB
            </h1>
            {getGitRepos()}

        </div>
    );
}

export default Work;
